import React from 'react';
/**
 * Cache 缓存
 * @Author gufuyan
 * @Date 2018-08-30
 */
class CacheFn {
    //函数参数默认值
    constructor() {
    }

    setCookie = (key, value, exdays) => {
        let d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        //document.cookie = key + "=" + value + "; " + expires+"; " + "domain=chinasie.com; path=/";
        document.cookie = key + "=" + value + "; " + expires;
    };

    getCookie = (key) => {
        if (!key)return null;
        let allcookies = document.cookie;
        let cookie_pos = allcookies.indexOf(key + "=");
        if (cookie_pos != -1) {
            cookie_pos += key.length + 1;
            let cookie_end = allcookies.indexOf(";", cookie_pos);
            if (cookie_end == -1) {
                cookie_end = allcookies.length;
            }
            return unescape(allcookies.substring(cookie_pos, cookie_end));
        }
        return null;
    };

    setLocal = (key, value) => {
        try {
            // ios safari 无痕模式下，直接使用 localStorage.setItem 会报错
            localStorage.setItem(key, value)
        } catch (ex) {
            // 开发环境下提示 error
            // if (__DEV__) {
            console.error('localStorage.setItem报错, ', ex.message);
            // }
        }
    };

    getLocal = (key) => {
        let value;
        try {
            value = localStorage.getItem(key)
        } catch (ex) {
            // 开发环境下提示error
            // if (__DEV__) {
            console.error('localStorage.getItem报错, ', ex.message);
            // }
        }
        finally {
            return value
        }
    };

    setSession = (key, value) => {
        try {
            // ios safari 无痕模式下，直接使用 localStorage.setItem 会报错
            sessionStorage.setItem(key, value)
        } catch (ex) {
            // 开发环境下提示 error
            // if (__DEV__) {
            console.error('sessionStorage.setItem报错, ', ex.message);
            // }
        }
    };

    getSession = (key) => {
        let value;
        try {
            value = sessionStorage.getItem(key)
        } catch (ex) {
            // 开发环境下提示error
            // if (__DEV__) {
            console.error('sessionStorage.getItem报错, ', ex.message);
            // }
        }
        finally {
            return value
        }
    };


}

let _Cache = new CacheFn();

export {_Cache}

